"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvProvider = exports.useEnv = void 0;
var tslib_1 = require("tslib");
/**
 * 给 Link 组件用来获取环境变量的 context
 */
var react_1 = tslib_1.__importStar(require("react"));
var envContext = react_1.createContext({ isBlue: false });
function useEnv() {
    return react_1.useContext(envContext);
}
exports.useEnv = useEnv;
function EnvProvider(_a) {
    var children = _a.children, _b = _a.isBlue, isBlue = _b === void 0 ? false : _b;
    return react_1.default.createElement(envContext.Provider, { value: { isBlue: isBlue } }, children);
}
exports.EnvProvider = EnvProvider;
//# sourceMappingURL=env.js.map